import { stringifyQs } from "@saleor/utils/urls";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Pagination,
  SingleAction
} from "../types";
import { CheckoutAddDetailsPageTab } from "./components/CheckoutAddDetails";

const checkoutAddSection = "/checkoutAdd/";
export const checkoutAddPath = checkoutAddSection;
export type CheckoutAddDialog = "assign-variant" | "unassign-variant";
export type CheckoutAddUrlQueryParams = Pagination &
  SingleAction &
  Dialog<CheckoutAddDialog> &
  BulkAction &
  ActiveTab<CheckoutAddDetailsPageTab>;

export const checkoutAddUrl = (params?: CheckoutAddUrlQueryParams) =>
  checkoutAddSection + "?" + stringifyQs(params);
